import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';

const SystemSettings = () => {
  return (
    <AdminLayout title="System Settings">
      <div className="dashboard-container">
        <div className="welcome-section">
          <h2 className="section-title">System Settings</h2>
          <p className="section-description">Configure application settings, API keys, and defaults.</p>
        </div>
        
        <div className="content-card">
          <div className="card-header">
            <h3 className="card-title">Settings</h3>
            <p className="card-subtitle">This page is under construction.</p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default SystemSettings; 